import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export {
  CloseButton,
  Overlay,
  SheetHeader,
  SheetPanel,
  SheetTitle,
} from "../sheet.style";

export const CriteriaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;

export const CriteriaItem = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const CriteriaNumber = styled.span`
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.bold};
  color: ${theme.blackText};
  flex-shrink: 0;
`;

export const CriteriaBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const CriteriaName = styled.p`
  margin: 0;
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.bold};
  color: ${theme.blackText};
`;

export const CriteriaDesc = styled.p`
  margin: 0;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.regular};
  color: ${theme.greyText};
  line-height: 1.45;
`;

export const PrimaryCta = styled.button`
  margin-top: 20px;
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: ${theme.blueGradient};
  color: ${theme.whiteText};
  font-size: ${fontSize.font16};
  font-weight: ${fontWeight.black};
  cursor: pointer;
`;
